var render, staticRenderFns
import script from "./TextField.vue?vue&type=script&lang=ts&"
export * from "./TextField.vue?vue&type=script&lang=ts&"
import style0 from "./TextField.vue?vue&type=style&index=0&id=31d328f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports